import React from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Pie } from 'react-chartjs-2';

// Register Chart.js components
ChartJS.register(ArcElement, Tooltip, Legend);

export interface PieChartProps {
  data: {
    labels: string[];
    datasets: {
      data: number[];
      backgroundColor?: string[];
      borderColor?: string[];
      borderWidth?: number;
    }[];
  };
  options?: any;
  height?: number | string;
  width?: number | string;
  className?: string;
  title?: string;
}

const PieChart: React.FC<PieChartProps> = ({
  data,
  options,
  height = 300,
  width = 300,
  className = '',
  title,
}) => {
  // Default options
  const defaultOptions = {
    maintainAspectRatio: false,
    responsive: true,
    plugins: {
      legend: {
        position: 'bottom' as const,
        labels: {
          boxWidth: 12,
          padding: 15,
          font: {
            size: 12,
          },
        },
      },
      tooltip: {
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
      },
    },
  };

  // Default colors that match your design system (using etpink-600 as a base)
  const defaultColors = [
    '#e91e63', // etpink-600
    '#3B82F6', // blue-500
    '#10B981', // green-500 
    '#F59E0B', // amber-500
    '#8B5CF6', // violet-500
    '#EC4899', // pink-500
    '#6366F1', // indigo-500
  ];

  // Apply default colors if none provided
  if (!data.datasets[0].backgroundColor) {
    data.datasets[0].backgroundColor = data.labels.map(
      (_, index) => defaultColors[index % defaultColors.length]
    );
  }

  const finalOptions = { ...defaultOptions, ...options };

  return (
    <div className={`flex flex-col ${className}`}>
      {title && (
        <h3 className="text-sm font-medium text-gray-700 text-center mb-2">{title}</h3>
      )}
      <div className="relative" style={{ width, height }}>
        <Pie data={data} options={finalOptions} />
      </div>
    </div>
  );
};

export default PieChart;